import { getLocalTranslation } from '../utils/i18nKit';
export var truelyValueMap = {
  yes: {
    value: 'yes',
    label: 'Yes'
  },
  no: {
    value: 'no',
    label: 'No'
  }
};
export var truelyValueMapList = Object.values(truelyValueMap);
export var getTruelyValueMap = function getTruelyValueMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    yes: {
      value: 'yes',
      label: $t('text:yes')
    },
    no: {
      value: 'no',
      label: $t('text:no')
    }
  };
};
export var getTruelyValueMapList = function getTruelyValueMapList() {
  return Object.values(getTruelyValueMap());
};
export var onlyTrueValueList = [{
  value: 'yes',
  label: 'Yes'
}];
export var validationExtractSourceMap = {
  chatgpt: {
    value: 'model_a',
    label: 'Model A'
  },
  gemini: {
    value: 'model_b',
    label: 'Model B'
  },
  deepseek: {
    value: 'model_c',
    label: 'Model C'
  }
};
export var validationExtractSourceList = Object.values(validationExtractSourceMap);
export var JOVE_PRICE_UNIT_CURRENCY_KEY = 'monetary';
export var JOVE_PRICE_UNIT_PERCENT_KEY = 'percentage';
export var DEFAULT_CURRENCY = 'GBP';
export var UK_CURRENCY = 'GBP';